import { render, staticRenderFns } from "./quinta-do-crasto.vue?vue&type=template&id=4b91c4c4&scoped=true"
import script from "./quinta-do-crasto.vue?vue&type=script&lang=js"
export * from "./quinta-do-crasto.vue?vue&type=script&lang=js"
import style0 from "./quinta-do-crasto.vue?vue&type=style&index=0&id=4b91c4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91c4c4",
  null
  
)

export default component.exports